import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-end" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_10 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_HospitalAdmissionForm = _resolveComponent("HospitalAdmissionForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isViewDetailsRequested ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: `${_ctx.formatDate(_ctx.hospitalization.AdmissionDate)} - ${_ctx.formatDate(_ctx.hospitalization.DischargeDate)}
                `
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.diagnosesList ? _ctx.diagnosesList : 'Unknown'
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.hospitalization.DischargedTo
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.hospitalization.Comments
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.hospitalization.IsEdEncounter ? 'Y' : 'N'
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", _hoisted_1, [
        (!_ctx.isEditRequested && !_ctx.isDeleteRequested && !_ctx.isViewDetailsRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_ctx.isEditRequested || _ctx.isViewDetailsRequested)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn table-btn btn-outline-info",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditHospitalization()))
                  }, _hoisted_4))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn table-btn btn-outline-danger",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDeleteHospitalization()))
              }, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                class: "btn table-btn btn-outline-info",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openHospitalizationView()))
              }, " View Details ")
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isEditRequested)
          ? (_openBlock(), _createElementBlock("i", _hoisted_7, "Edit in Progress"))
          : _createCommentVNode("v-if", true),
        (_ctx.isDeleteRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_TablePrompt, {
                "ok-text": "delete",
                cancel: _ctx.closeDeleteHospitalization,
                message: "Are you sure you want to delete this hospitalization?",
                ok: _ctx.deleteHospitalization,
                "is-in-progress": _ctx.isDeleteInProgress
              }, null, 8 /* PROPS */, ["cancel", "ok", "is-in-progress"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" EDIT "),
    (_ctx.isEditRequested || _ctx.isViewDetailsRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            _createVNode(_component_HospitalAdmissionForm, {
              hospitalization: _ctx.cachedData,
              "cancel-hospitalization": _ctx.closeEditHospitalization,
              "save-hospitalization": _ctx.editHospitalization,
              "is-loading": _ctx.isLoading,
              "provider-id": _ctx.providerId,
              roles: _ctx.roles,
              "patient-info": _ctx.patientInfo,
              "close-view-details-window": _ctx.closeViewDetailsWindow,
              "is-view-details-requested": _ctx.isViewDetailsRequested,
              application: _ctx.application,
              accountId: _ctx.accountId
            }, null, 8 /* PROPS */, ["hospitalization", "cancel-hospitalization", "save-hospitalization", "is-loading", "provider-id", "roles", "patient-info", "close-view-details-window", "is-view-details-requested", "application", "accountId"])
          ], 8 /* PROPS */, _hoisted_10)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}